import { render, staticRenderFns } from "./ArticleArchives.vue?vue&type=template&id=1425b729&scoped=true&"
import script from "./ArticleArchives.vue?vue&type=script&lang=js&"
export * from "./ArticleArchives.vue?vue&type=script&lang=js&"
import style0 from "./ArticleArchives.vue?vue&type=style&index=0&id=1425b729&lang=scss&scoped=true&"
import style1 from "./ArticleArchives.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1425b729",
  null
  
)

export default component.exports